import { render, staticRenderFns } from "./DocumentItem.vue?vue&type=template&id=3d923850&"
import script from "./DocumentItem.vue?vue&type=script&lang=js&"
export * from "./DocumentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports